/**
 * ConciergeGalleryCard — the Concierge's face inside the home agent grid.
 *
 * POSITIONING: always the FIRST card, same cell and same size as every agent
 * card. It is recognisably not a specialist agent, but it does not shout.
 *
 * How it differs now that the compass mark is gone: it is the only CENTRED
 * card in the grid — no coin in the corner, no left-aligned text block, just
 * the name set large in the middle with one line under it. That difference in
 * composition is enough to mark it as a different kind of thing, and on hover
 * a slow shimmer sweeps across it, which no agent card does.
 *
 * This component renders the card's INNER content only — the gallery owns the
 * <button> wrapper so the Concierge and the agents share one hit target and
 * one grid cell definition.
 */

import { useLanguage } from '@/hooks/useLanguage';
import './ConciergeGalleryCard.css';

/** Class the gallery adds to the Concierge's card so this file can style it. */
export const CONCIERGE_GALLERY_CARD_CLASS = 'ag-card-concierge';

export function ConciergeCardFace() {
  const { t } = useLanguage();

  return (
    <>
      {/* The sweep lives on its own layer so it can be clipped to the card
          without the text inheriting any of its blending. */}
      <span className="cg-shimmer" aria-hidden="true" />
      <span className="cg-content">
        <span className="cg-eyebrow">{t('concierge.card.badge')}</span>
        <span className="cg-title">{t('concierge.title')}</span>
        <span dir="auto" className="cg-sub">{t('concierge.greeting')}</span>
      </span>
    </>
  );
}
